// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmModal_container__dtTnA","textArea":"ConfirmModal_textArea__2CU_V","buttonContainer":"ConfirmModal_buttonContainer__3RXKp"};